import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import CommercialContractorsHero from './components/CommercialContractorsHero';
import CommercialContractorsServices from './components/CommercialContractorsServices';
import ProjectTypesElPaso from './components/ProjectTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import CommercialContractorsFAQ from './components/CommercialContractorsFAQ';

export default function CommercialContractorsPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <CommercialContractorsHero />
        <CommercialContractorsServices />
        <ProjectTypesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <CommercialContractorsFAQ />
      </main>
      <Footer />
    </div>
  );
}
